<template>
  <div class="home-page">
    <!-- Hero：全屏三图轮播（纯 CSS 交叉淡入 + 轻微 Ken Burns） -->
    <section class="hero hero-full">
      <div class="hero-bg" aria-hidden="true">
        <div class="hero-slide s1"></div>
        <div class="hero-slide s2"></div>
        <div class="hero-slide s3"></div>
      </div>
      <div class="container">
        <div class="eyebrow">DATA MONITORING · API SERVICE · 商业数据监控与调用</div>
        <h1>让每一条商业数据<br />都被<span>实时看见</span>、安全调用</h1>
        <p>动态时序科技专注商业数据监控&amp;调用及数据技术服务，以湖仓一体的现代数据架构，为各行业企业构建安全、高效、可溯源的数据基础设施。</p>
        <div class="hero-actions">
          <router-link class="btn btn-primary" to="/api">了解数据产品</router-link>
          <router-link class="btn btn-ghost" to="/contact">预约演示</router-link>
        </div>
      </div>
      <div class="scroll-cue" aria-hidden="true"></div>
    </section>

    <!-- ============ 01 公司介绍 ============ -->
    <section class="band">
      <div class="container">
        <div class="band-head">
          <span class="band-num">01</span>
          <h2>公司介绍</h2>
          <span class="rule"></span>
        </div>
        <div class="intro-split">
          <div class="article">
            <p class="lead">以数据的时序之力，让企业的每一次决策都建立在事实之上。</p>
            <p>
              北京动态时序科技有限公司成立于 2021 年，位于北京海淀，坐拥中关村区位优势，服务北京与全国创新型企业。公司长期专注于商业数据实时监控、数据清洗、企业关联等服务，持续输出稳定可靠的数据技术服务能力。核心团队出自一线互联网与大数据企业，团队成员
              <b>90% 以上</b>为技术人员，其中 <b>50% 以上</b>具备硕士及以上学历。
            </p>
            <p>
              公司成立第三年即获评<b>国家高新技术企业</b>，数据<b>覆盖主体数量 4亿+、司法信息条数约 7.5亿</b>。
            </p>
            <router-link class="learn-more" to="/aboutUs">Learn more <span class="arrow">→</span></router-link>
          </div>
          <figure class="intro-photo">
            <img :src="buildingImg" alt="北京市海淀区北三环西路32号 恒润国际大厦" />
            <figcaption>北京海淀 · 恒润国际大厦</figcaption>
          </figure>
        </div>

        <div class="honors">
          <div class="honors-title">我们的能力</div>
          <div class="honors-grid">
            <div class="honor-item">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="9" r="6"></circle><path d="M9 14.5 7.5 21l4.5-2.5L16.5 21 15 14.5"></path></svg>
              <div><b>国家高新技术企业</b><span>2024</span></div>
            </div>
            <div class="honor-item">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M8 21h8M12 17v4M6 3h12v6a6 6 0 0 1-12 0V3z"></path><path d="M6 5H3v2a4 4 0 0 0 3 3.87M18 5h3v2a4 4 0 0 1-3 3.87"></path></svg>
              <div><b>中关村管委会筑基项目奖金</b><span>2024</span></div>
            </div>
            <div class="honor-item">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M12 2l2.6 5.3 5.9.9-4.2 4.1 1 5.8L12 15.4 6.7 18.1l1-5.8L3.5 8.2l5.9-.9L12 2z"></path></svg>
              <div><b>创新型中小企业</b><span>2025 · 北京科信局</span></div>
            </div>
            <div class="honor-item">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M3 21h18M5 21V7l7-4 7 4v14"></path><path d="M9 21v-4h6v4M9 11h.01M15 11h.01M12 11h.01"></path></svg>
              <div><b>A 级纳税人</b><span>2025</span></div>
            </div>
            <div class="honor-item">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6z"></path><path d="M14 2v6h6M9 13h6M9 17h4"></path></svg>
              <div><b>覆盖主体数量 4亿+</b><span>企业主体库</span></div>
            </div>
            <div class="honor-item">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><path d="M2 12h20M12 2a15.3 15.3 0 0 1 0 20 15.3 15.3 0 0 1 0-20z"></path></svg>
              <div><b>司法信息条数 ~7.5亿</b><span>司法数据源</span></div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 数据概览（影像带） -->
    <section class="stats-band">
      <video class="band-video" autoplay muted loop playsinline preload="auto" :poster="bandPoster" aria-hidden="true">
        <source :src="bandVideo" type="video/mp4" />
      </video>
      <div class="container">
        <div class="stats">
          <div class="stat"><b>100+</b><span>企业终端用户</span></div>
          <div class="stat"><b>200+</b><span>标准/可定制化接口</span></div>
          <div class="stat"><b>4亿+</b><span>覆盖主体数量</span></div>
          <div class="stat"><b>~7.5亿</b><span>司法信息条数</span></div>
        </div>
      </div>
    </section>

    <!-- ============ 02 客户案例 ============ -->
    <section class="band">
      <div class="container">
        <div class="band-head">
          <span class="band-num">02</span>
          <h2>客户案例</h2>
          <span class="rule"></span>
        </div>
        <p class="band-lead">从主数据管理到定制化数据获取，我们为生物制药、政务管理、园林环保、货币金融等各行业客户交付了可信可验证的成果。</p>
        <div class="grid grid-2">
          <div class="card case-card case-card-feat">
            <span class="case-tag">商业查询数据供应</span>
            <h3>企业多维度信息定制与交付</h3>
            <p class="case-body">持续深耕商业数据监控、数据调用与数据技术服务领域。可根据用户需求提供全国市场主体工商与司法数据的采集、清洗、去重与标准化供给：覆盖 <b>4亿+</b> 主体、<b>7.5亿条</b>司法信息等；可通过 API <b>实时查询</b>与批量离线包（CSV / JSON）等多种方式交付，支撑平台端的工商档案、司法涉诉、知识产权等查询场景。</p>
          </div>
          <div class="card case-card case-card-feat">
            <span class="case-tag">主数据管理</span>
            <h3>企业主数据管理平台</h3>
            <p class="case-body">为多家A股上市公司建设主数据体系，覆盖物料、供应商、客户、项目/WBS、人员等<b>主数据域</b>，完成数据规划、治理、系统集成与接口开发，打通 ERP、CRM、SRM、WMS、MES 等<b>十余个业务系统</b>，统一服务调度，集成业务、数据、技术<b>三大平台接口</b>；降低数据治理门槛，支持多条线业务人员参与数据管道设计与数据分析；提升数据时效性，支撑<b>业务创新</b>与<b>快速决策</b>。</p>
          </div>
          <div class="card case-card">
            <span class="case-tag">关联关系数据服务</span>
            <h3>商业查询平台企业关联图谱数据</h3>
            <p class="case-body">服务各大机构用户及信用平台，基于工商股权关联信息、司法关联方、共有知识产权等数据搭建企业<b>关系图谱</b>，向上递归追溯股东至自然人或国资主体、向下穿透至<b>末级运营主体</b>，自动识别合伙企业 GP、累计计算<b>多层持股</b>比例并检测循环持股；输出实际控制人、受益所有人、疑似关联方等标签，供平台的关联排查、尽调与风控场景直接调用。</p>
          </div>
          <div class="card case-card">
            <span class="case-tag">数据治理 + AI</span>
            <h3>储能产业经贸规则数据治理</h3>
            <p class="case-body">为某研究机构开发基于大模型的 AI 工具，对 WTO 通报文件、美国 CPSC / 欧盟 RAPEX 召回数据、多国法规数据进行智能阅读与语义打标，并按客户指定规范自动生成定制化报告与总结。支持对结构化数据库 RDS、DRDS、PolarDB、OceanBase、ECS 自建数据库，非结构化数据存储 OSS、OTS，大数据平台 MaxCompute 的<b>数据审计与防护</b>；支持敏感数据识别后，<b>一键开启</b>列加密和图片脱敏进行治理。</p>
          </div>
        </div>
      </div>
    </section>

    <!-- 客户 Logo 无缝滚动墙 -->
    <section class="clients">
      <div class="container clients-head">
        <div class="eyebrow clients-eyebrow">Trusted By</div>
      </div>
      <div class="marquee">
        <div class="marquee-track">
          <div class="client-logo" v-for="(logo, i) in marqueeLogos" :key="i" :title="logo.title">
            <img :src="logo.src" :alt="logo.title" loading="lazy" />
          </div>
        </div>
      </div>
    </section>

    <!-- ============ 03 我们的能力 ============ -->
    <section class="band cap-stage">
      <div class="container">
        <div class="band-head">
          <span class="band-num">03 / CAPABILITY</span>
          <h2>DATA + AI，打造数据智能产品体系</h2>
          <span class="rule"></span>
        </div>
        <p class="band-lead">覆盖数据「存、算、管、用」全环节——湖仓一体为底座、离线实时双引擎、统一治理可溯源、自研 API 即取即用，每一层能力都可根据用户需求成为可交付、可调用的产品，各环节均可提供配套的技术服务。</p>
        <div class="cap-row">
          <div class="cap-col">
            <div class="cap-top">
              <span class="cap-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><ellipse cx="12" cy="5" rx="8.5" ry="3"></ellipse><path d="M3.5 5v14c0 1.66 3.8 3 8.5 3s8.5-1.34 8.5-3V5"></path><path d="M3.5 12c0 1.66 3.8 3 8.5 3s8.5-1.34 8.5-3"></path></svg>
              </span>
              <span class="cap-tag">01 / STORE</span>
            </div>
            <h3>数据存储</h3>
            <div class="sub">DATA STORAGE · 湖仓一体底座</div>
            <p>数据库、数据仓库、数据湖统一纳管，分布式存储承载海量数据，冷热分层无缝互通，从容应对复杂多样的存储需求。</p>
            <ul class="cap-chips">
              <li>湖仓一体</li><li>冷热分层</li><li>统一纳管</li><li>分布式扩展</li>
            </ul>
            <router-link class="cap-more" to="/api">了解详情 <span class="arr">→</span></router-link>
          </div>
          <div class="cap-col">
            <div class="cap-top">
              <span class="cap-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="6.5" y="6.5" width="11" height="11" rx="2"></rect><rect x="10.2" y="10.2" width="3.6" height="3.6" rx="1"></rect><path d="M9.5 2.5v4M14.5 2.5v4M9.5 17.5v4M14.5 17.5v4M2.5 9.5h4M2.5 14.5h4M17.5 9.5h4M17.5 14.5h4"></path></svg>
              </span>
              <span class="cap-tag">02 / COMPUTE</span>
            </div>
            <h3>数据计算</h3>
            <div class="sub">DATA COMPUTE · 离线实时双引擎</div>
            <p>Spark 提供离线批量计算提速，Flink 流批一体支撑实时计算，建模分析快人一步，计算负载与业务系统彻底解耦。</p>
            <ul class="cap-chips">
              <li>Spark 批计算</li><li>Flink 流批一体</li><li>实时指标</li><li>负载解耦</li>
            </ul>
            <router-link class="cap-more" to="/api">了解详情 <span class="arr">→</span></router-link>
          </div>
          <div class="cap-col">
            <div class="cap-top">
              <span class="cap-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M12 2.2l7.5 2.8v6.1c0 4.8-3.3 8.6-7.5 10.7C7.8 19.7 4.5 15.9 4.5 11.1V5z"></path><path d="M8.6 11.8l2.4 2.4 4.4-4.6"></path></svg>
              </span>
              <span class="cap-tag">03 / GOVERN</span>
            </div>
            <h3>数据治理</h3>
            <div class="sub">DATA GOVERN · 统一口径可溯源</div>
            <p>DolphinScheduler 统一任务调度，Kafka 消息队列贯通数据链路；数据标准、元数据与质量管理，实现可查、可溯源、可理解。</p>
            <ul class="cap-chips">
              <li>统一调度</li><li>消息贯通</li><li>元数据管理</li><li>异常监控</li>
            </ul>
            <router-link class="cap-more" to="/api">了解详情 <span class="arr">→</span></router-link>
          </div>
          <div class="cap-col">
            <div class="cap-top">
              <span class="cap-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="6" cy="12" r="2.6"></circle><circle cx="18" cy="5.5" r="2.6"></circle><circle cx="18" cy="18.5" r="2.6"></circle><path d="M8.4 10.8l7.2-4M8.4 13.2l7.2 4"></path></svg>
              </span>
              <span class="cap-tag">04 / SERVE</span>
            </div>
            <h3>数据服务</h3>
            <div class="sub">DATA SERVICE · 自研 API 即取即用</div>
            <p>Java 自研 API 接口将用户标签、订单模型等数据资产服务化输出，权限管控、按需调用，让数据直接赋能业务决策。</p>
            <ul class="cap-chips">
              <li>自研 API</li><li>资产化输出</li><li>权限管控</li><li>按需调用</li>
            </ul>
            <router-link class="cap-more" to="/api">了解详情 <span class="arr">→</span></router-link>
          </div>
        </div>
      </div>
    </section>

    <!-- ============ 04 比较优势 ============ -->
    <section class="band">
      <div class="container">
        <div class="band-head">
          <span class="band-num">04</span>
          <h2>比较优势</h2>
          <span class="rule"></span>
        </div>
        <p class="band-lead">与传统数据架构相比，动态时序科技有限公司有提供湖仓一体方案在存储、计算、治理与场景化应用等更层面数据技术与服务的全面搭建技术能力与技术服务能力。</p>
        <div class="compare">
          <div class="compare-col compare-old">
            <div class="compare-head">
              传统数据架构
              <small>Traditional Architecture</small>
            </div>
            <ul>
              <li>传统存储结构无法应对复杂多样的数据需求</li>
              <li>传统数据库仅支持简单增改删查，库内建模、建表搜索效率低、速度慢</li>
              <li>分析需求与业务系统互相影响，分析负载拖慢业务运行</li>
              <li>缺乏统一的任务管理与监控体系，风险难以预警</li>
              <li>数据口径不一、权限分散，难以资产化复用</li>
            </ul>
          </div>
          <div class="compare-col compare-new">
            <div class="compare-head">
              动态时序 · 湖仓一体方案
              <small>Lakehouse Architecture by DTS</small>
            </div>
            <ul>
              <li>湖仓一体、冷热分层，存储无缝互通，从容应对复杂需求</li>
              <li>Spark 离线提速 + Flink 实时计算，建模分析快人一步</li>
              <li>计算与业务解耦，分析负载不再影响业务系统</li>
              <li>全链路任务调度与异常监控，统一口径、权限管控</li>
              <li>数据资产化、服务化，API 按需调用，价值直达业务</li>
            </ul>
          </div>
        </div>
      </div>
    </section>

    <!-- CTA -->
    <section class="section home-cta">
      <div class="container">
        <div class="cta cta-photo">
          <h2>准备好让数据为业务加速了吗？</h2>
          <p>联系我们的解决方案团队，获取一对一产品演示与试用账号。</p>
          <router-link class="btn" to="/contact">联系我们</router-link>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
/* 首页
   结构与交互移植自 website-handoff/index.html：
   Hero 三图纯 CSS 轮播、01 公司介绍 + 我们的能力网格、数据概览影像带、02 客户案例 + 客户 Logo 无缝滚动墙、
   03 能力弹性放大卡片、04 比较优势左右对比、CTA 影像区。
   本页为纯展示页，不涉及任何接口调用。 */
export default {
  name: 'index',
  data() {
    return {
      buildingImg: require('../../assets/handoff/hengrun-building.jpg'),
      bandVideo: require('../../assets/handoff/cbd-band.mp4'),
      bandPoster: require('../../assets/handoff/cbd-band-poster.jpg'),
      // 客户名称一律匿名化（仅以行业 + 规模口径描述），避免披露真实客户名
      logos: [
        { title: '某直辖市园林绿化大数据中心', src: require('../../assets/handoff/clients/garden.png') },
        { title: '某沿海城市水务集团', src: require('../../assets/handoff/clients/qdwater.png') },
        { title: '某一线城市标准技术研究院', src: require('../../assets/handoff/clients/sist.png') },
        { title: '某生物医药上市公司', src: require('../../assets/handoff/clients/wantai.png') },
        { title: '某头部金融科技集团', src: require('../../assets/handoff/clients/antgroup.png') },
        { title: '某财经类高校', src: require('../../assets/handoff/clients/cueb.png') },
        { title: '倍智智能', src: require('../../assets/handoff/clients/beizhi.png') },
        { title: '某老字号医药集团', src: require('../../assets/handoff/clients/trt.png') },
        { title: '某头部创投机构', src: require('../../assets/handoff/clients/hongshan.png') },
        { title: '某产业园区运营商', src: require('../../assets/handoff/clients/liando.png') },
        { title: '某国家级招投标服务平台', src: require('../../assets/handoff/clients/ceb.png') },
        { title: '某信用科技企业', src: require('../../assets/handoff/clients/vzoom.png') }
      ]
    };
  },
  computed: {
    // 内容复制两份，配合 translateX(-50%) 实现无缝循环（与 handoff 结构一致）
    marqueeLogos() {
      return this.logos.concat(this.logos);
    }
  }
};
</script>

<style lang="less" scoped>
/* 首页专属微调（其余样式来自 src/styles/site.css 的 handoff 设计体系） */
.home-cta {
  padding: 0 0 96px;
}
</style>



// WEBPACK FOOTER //
// src/views/index/index.vue